import { render, staticRenderFns } from "./DefaultLayoutSidebarLogo.vue?vue&type=template&id=423a11b9&"
import script from "./DefaultLayoutSidebarLogo.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutSidebarLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VFadeTransition,VImg})
